"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchFilter = void 0;
var linkClick_1 = require("./linkClick");
var searchFilter = function (event) {
    var _a, _b, _c, _d, _e;
    var filterString = "".concat((_b = (_a = event === null || event === void 0 ? void 0 : event.eventData) === null || _a === void 0 ? void 0 : _a.searchFilter) === null || _b === void 0 ? void 0 : _b.searchFacetTitle, ":").concat((_d = (_c = event === null || event === void 0 ? void 0 : event.eventData) === null || _c === void 0 ? void 0 : _c.searchFilter) === null || _d === void 0 ? void 0 : _d.searchFacetValue);
    var mainEventData = {
        event: 'search-filter',
        eventInfo: 'search-filter',
        search: {
            searchFilter: filterString,
        },
    };
    var linkEventData = (0, linkClick_1.linkClick)(filterString, ((_e = event.eventData.linkClick) === null || _e === void 0 ? void 0 : _e.linkModule) || 'coveo-facet-values', '');
    return [mainEventData, linkEventData];
};
exports.searchFilter = searchFilter;
